/**
 * Reusable Notes Field Component
 * Can be used in both DetailsStep and RmcOrderEdit with consistent styling and behavior
 */

import {useAdditionalNotes} from '@hconnect/tuc-processes/fields/textField'
import {ControlledTextarea} from '@hm/fundamental'
import {Box} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

/**
 * Reusable Notes Field component with consistent styling
 */
export const NotesField: React.FC = () => {
  const {t} = useTranslation()
  const {additionalNotes, setAdditionalNotes, additionalNotesConfiguration, error} =
    useAdditionalNotes()

  const label = t('orderIntake.rmc.steps.shared.additionalNotesLabel')
  const maxLengthErrorMessage = t('orderIntake.rmc.fieldValidation.additionalNotesMaxLength')
  const defaultHint = t('orderIntake.rmc.steps.details.additionalNotesHelper')

  const maxLength = additionalNotesConfiguration?.maxLength ?? 0
  const currentLength = (additionalNotes ?? '').length

  const handleAdditionalNotesChange = React.useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      const newValue = event.target.value
      setAdditionalNotes(newValue)
    },
    [setAdditionalNotes]
  )

  return (
    <>
      <ControlledTextarea
        name={label}
        label={label}
        value={additionalNotes}
        onChange={handleAdditionalNotesChange}
        isDisabled={false}
        data-test-id="notes-input"
        state={error ? 'error' : undefined}
        hint={error ? maxLengthErrorMessage : defaultHint}
      />

      <Box
        data-test-id="notes-character-counter"
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          fontSize: '12px',
          lineHeight: '16px',
          color: error ? 'error.main' : '#52667a'
        }}
      >
        {`${currentLength}/${maxLength}`}
      </Box>
    </>
  )
}
